/* Shared helper: add-to-cart that refreshes the theme's cart drawer.
 *
 * - window.AshCartAdd.submit(form, { sourceId }) — programmatic add.
 * - Document-level submit delegation for [data-ash-cup-form] (works after section morphs).
 * - Auto-hides any [data-ash-cup-product-id] whose product is already in cart.
 * - Dispatches a `cart:update` CustomEvent on document so <cart-items-component>
 *   morphs its section, and triggers <cart-drawer-component auto-open>. */
(function () {
  if (window.AshCartAdd) return;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function collectCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset && el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function dispatchUpdate(cart, sections, sourceId) {
    var ev = new CustomEvent('cart:update', {
      bubbles: true,
      cancelable: true,
      detail: {
        resource: cart,
        sourceId: sourceId || 'ash-cart-add',
        data: {
          sections: sections || {},
          source: sourceId || 'ash-cart-add',
          itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined
        }
      }
    });
    document.dispatchEvent(ev);
  }

  function submit(form, opts) {
    opts = opts || {};
    var sourceId = opts.sourceId || 'ash-cart-add';
    var sectionIds = collectCartSectionIds();
    var fd = new FormData(form);
    if (sectionIds.length) {
      fd.delete('sections');
      fd.append('sections', sectionIds.join(','));
    }
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw Object.assign(new Error('cart-add-failed'), { response: data });
          return data;
        });
      })
      .then(function (added) {
        var sections = added && added.sections ? added.sections : null;
        return fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            dispatchUpdate(cart, sections, sourceId);
            return cart;
          });
      });
  }

  /* ===== Cart-upsell behaviors (delegated, survive section morphs) ===== */

  function syncUpsellVisibility(cart) {
    if (!cart || !cart.items) return;
    var ids = {};
    cart.items.forEach(function (it) { ids[String(it.product_id)] = true; });
    document.querySelectorAll('.ash-cup[data-product-id]').forEach(function (el) {
      el.style.display = ids[String(el.dataset.productId)] ? 'none' : '';
    });
  }

  function refreshUpsellVisibility() {
    fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(syncUpsellVisibility)
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-ash-cup-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    submit(form, { sourceId: 'ash-cart-upsell' })
      .then(function () {
        if (btn) btn.textContent = '✓';
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } }, 1300);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } });
  });

  function applyCarouselIndex(carousel) {
    var track = carousel.querySelector('[data-ash-cup-track]');
    var slides = carousel.querySelectorAll('.ash-cup__slide');
    if (!track || !slides.length) return;
    var idx = parseInt(carousel.getAttribute('data-index'), 10) || 0;
    if (idx < 0) idx = slides.length - 1;
    if (idx >= slides.length) idx = 0;
    carousel.setAttribute('data-index', idx);
    track.style.transform = 'translate3d(' + (-idx * 100) + '%, 0, 0)';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ash-cup-nav]');
    if (!btn) return;
    e.preventDefault();
    var carousel = btn.closest('[data-ash-cup-carousel]');
    if (!carousel) return;
    var slides = carousel.querySelectorAll('.ash-cup__slide');
    if (slides.length < 2) return;
    var idx = parseInt(carousel.getAttribute('data-index'), 10) || 0;
    var dir = btn.getAttribute('data-ash-cup-nav') === 'prev' ? -1 : 1;
    var next = (idx + dir + slides.length) % slides.length;
    carousel.setAttribute('data-index', next);
    applyCarouselIndex(carousel);
  });

  /* Reset carousel position to the first slide whenever the section morphs */
  function resetAllCarousels() {
    document.querySelectorAll('[data-ash-cup-carousel]').forEach(function (c) {
      c.setAttribute('data-index', '0');
      var track = c.querySelector('[data-ash-cup-track]');
      if (track) track.style.transform = 'translate3d(0, 0, 0)';
    });
  }
  document.addEventListener('cart:update', resetAllCarousels);

  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, refreshUpsellVisibility);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshUpsellVisibility, { once: true });
  } else {
    refreshUpsellVisibility();
  }

  window.AshCartAdd = { submit: submit };
})();
